
export interface SiteMapEntry {
  name: string;
  subEntries?: SiteMapEntry[];
  key?: string;
}

const sitemap: SiteMapEntry[] = [
  {
    "name": "OnData Portal",
    "subEntries": [
      {
        "name": "Account Registration",
        "key": "/ondata_portal/account_registration"
      },
      {
        "name": "User Management",
        "key": "/ondata_portal/user_management"
      },
      {
        "name": "OnData Application Roles",
        "key": "/ondata_portal/ondata_application_roles"
      },
      {
        "name": "Data Classifications",
        "key": "/ondata_portal/data_classifications"
      },
      {
        "name": "Data Access Roles",
        "key": "/ondata_portal/data_access_roles"
      },
      {
        "name": "SSO Integration",
        "subEntries": [
          {
            "name": "Overview",
            "key": "/ondata_portal/sso_integration/overview"
          },
          {
            "name": "EntraID Integration Using OIDC",
            "key": "/ondata_portal/sso_integration/entraid_integration_using_oidc"
          },
          {
            "name": "EntraID Integration Using SAML",
            "key": "/ondata_portal/sso_integration/entraid_integration_using_saml"
          },
          {
            "name": "EntraID Role Assignment",
            "key": "/ondata_portal/sso_integration/entraid_role_assignment"
          },
          {
            "name": "Okta Integration Using OIDC",
            "key": "/ondata_portal/sso_integration/okta_integration_using_oidc"
          },
          {
            "name": "Okta Integration Using SAML",
            "key": "/ondata_portal/sso_integration/okta_integration_using_saml"
          },
          {
            "name": "Okta Role Assignment",
            "key": "/ondata_portal/sso_integration/okta_role_assignment"
          }
        ]
      },
      {
        "name": "Custom Cloud Subscription",
        "key": "/ondata_portal/custom_cloud_subscription"
      },
      {
        "name": "Custom Key Vault",
        "key": "/ondata_portal/custom_key_vault"
      }
    ]
  },
  {
    "name": "SecureDB",
    "subEntries": [
      {
        "name": "Database Backup",
        "subEntries": [
          {
            "name": "Microsoft SQL Server",
            "key": "/securedb/database_backup/microsoft sql server"
          },
          {
            "name": "Oracle",
            "key": "/securedb/database_backup/oracle"
          },
          {
            "name": "PostgreSQL",
            "key": "/securedb/database_backup/postgresql"
          },
          {
            "name": "MySQL",
            "key": "/securedb/database_backup/mysql"
          },
          {
            "name": "MariaDB",
            "key": "/securedb/database_backup/mariadb"
          },
          {
            "name": "Snowflake",
            "key": "/securedb/database_backup/snowflake"
          },
          {
            "name": "DB2",
            "key": "/securedb/database_backup/db2"
          }
        ]
      },
      {
        "name": "Database Download",
        "subEntries": [
          {
            "name": "Download Databases",
            "key": "/securedb/database_download/download_databases"
          }
        ]
      },
      {
        "name": "Database Drivers",
        "subEntries": [
          {
            "name": "OnData ODBC Driver",
            "key": "/securedb/database_drivers/ondata_odbc_driver"
          },
          {
            "name": "OnData JDBC Driver",
            "key": "/securedb/database_drivers/ondata_jdbc_driver"
          },
          {
            "name": "OnData SqlClient",
            "key": "/securedb/database_drivers/ondata_sqlclient"
          },
          {
            "name": "OnData Client Registration",
            "key": "/securedb/database_drivers/ondata_client_registration"
          },
          {
            "name": "Client Resource Access",
            "key": "/securedb/database_drivers/client_resource_access"
          }
        ]
      },
      {
        "name": "OnData Encryption",
        "subEntries": [
          {
            "name": "OnData Encryption Tool Overview",
            "key": "/securedb/ondata_encryption/ondata_encryption_tool_overview"
          },
          {
            "name": "Install OnData Encryption Tool",
            "key": "/securedb/ondata_encryption/install_ondata_encryption_tool"
          },
          {
            "name": "Use OnData Encryption Tool",
            "key": "/securedb/ondata_encryption/use_ondata_encryption_tool"
          },
          {
            "name": "Automate OnData Encryption Tool",
            "key": "/securedb/ondata_encryption/automate_ondata_encryption_tool"
          },
          {
            "name": "Migrate and Encrypt Oracle Database",
            "key": "/securedb/ondata_encryption/migrate_and_encrypt_oracle_database"
          },
          {
            "name": "Apply Encryption Setting Changes",
            "key": "/securedb/ondata_encryption/apply_encryption_setting_changes"
          },
          {
            "name": "Database Subsetting",
            "key": "/securedb/ondata_encryption/database_subsetting"
          },
          {
            "name": "OnData Encryption Rules",
            "key": "/securedb/ondata_encryption/ondata_encryption_rules"
          },
          {
            "name": "Encryption Best Practices and Limitations",
            "key": "/securedb/ondata_encryption/encryption_best_practices_and_limitations"
          },
          {
            "name": "MongoDB Encryption Limitations",
            "key": "/securedb/ondata_encryption/mongodb_encryption_limitations"
          },
          {
            "name": "Data Information Types",
            "key": "/securedb/ondata_encryption/data_information_types"
          }
        ]
      }
    ]
  },
  {
    "name": "SecureFile",
    "subEntries": [
      {
        "name": "Installation and Configuration",
        "subEntries": [
          {
            "name": "Overview",
            "key": "/securefile/installation_and_configuration/overview"
          },
          {
            "name": "Install SecureFile on Windows",
            "key": "/securefile/installation_and_configuration/install_securefile_on_windows"
          },
          {
            "name": "Register SecureFile",
            "key": "/securefile/installation_and_configuration/register_securefile"
          },
          {
            "name": "Silent Installation on Windows",
            "key": "/securefile/installation_and_configuration/silent_installation_on_windows"
          },
          {
            "name": "Install SecureFile on MacOS",
            "key": "/securefile/installation_and_configuration/install_securefile_on_macos"
          },
          {
            "name": "Silent Installation on MacOS",
            "key": "/securefile/installation_and_configuration/silent_installation_on_macos"
          },
          {
            "name": "SecureFile Settings on MacOS",
            "key": "/securefile/installation_and_configuration/securefile_settings_on_macos"
          },
          {
            "name": "Uninstall SecureFile",
            "key": "/securefile/installation_and_configuration/uninstall_securefile"
          }
        ]
      },
      {
        "name": "Using SecureFile",
        "key": "/securefile/using_securefile"
      },
      {
        "name": "Sharing Files with External Users",
        "key": "/securefile/sharing_files_with_external_users"
      },
      {
        "name": "Best Practices and Limitations",
        "key": "/securefile/best_practices_and_limitations"
      },
      {
        "name": "SecureFile Settings",
        "key": "/securefile/securefile_settings"
      },
      {
        "name": "Classification and Protection Rules",
        "key": "/securefile/classification_and_protection_rules"
      },
      {
        "name": "File Information Types",
        "key": "/securefile/file_information_types"
      },
      {
        "name": "Document Types",
        "key": "/securefile/document_types"
      },
      {
        "name": "Deploy Data Analyzer",
        "key": "/securefile/deploy_data_analyzer"
      }
    ]
  },
  {
    "name": "SecureAI",
    "subEntries": [
      {
        "name": "SecureAI Overview",
        "key": "/secureai/secureai_overview"
      },
      {
        "name": "Installation and Configuration",
        "subEntries": [
          {
            "name": "Overview",
            "key": "/secureai/installation_and_configuration/overview"
          },
          {
            "name": "Deploy with Docker",
            "key": "/secureai/installation_and_configuration/deploy_with_docker"
          },
          {
            "name": "Configure SecureAI App",
            "key": "/secureai/installation_and_configuration/configure_secureai_app"
          },
          {
            "name": "SSO Integration",
            "key": "/secureai/installation_and_configuration/sso_integration"
          }
        ]
      },
      {
        "name": "Data Query",
        "key": "/secureai/data_query"
      },
      {
        "name": "Agent Automation",
        "key": "/secureai/agent_automation"
      }
    ]
  }
];

export default sitemap
  